<template>
    <v-container class="header">
        <div class="header-title" :class="{'md': $vuetify.breakpoint.smAndUp}">
            <router-link to="/">
            <div class="logotype">
                Blastronaut
                <svg viewBox="0 0 1271 131" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M85.2719 64.386C92.8666 66.166 98.7406 69.8446 102.894 75.422C107.166 80.8806 109.302 87.2293 109.302 94.468C109.302 105.504 105.623 114.048 98.2659 120.1C91.0272 126.033 80.5846 129 66.9379 129H0.899902V2.97597H65.1579C77.9739 2.97597 88.0606 5.76464 95.4179 11.342C102.775 16.9193 106.454 25.048 106.454 35.728C106.454 43.0853 104.496 49.3153 100.58 54.418C96.7826 59.402 91.6799 62.7246 85.2719 64.386ZM40.4159 52.104H55.7239C59.2839 52.104 61.8946 51.392 63.5559 49.968C65.3359 48.544 66.2259 46.3486 66.2259 43.382C66.2259 40.2966 65.3359 38.042 63.5559 36.618C61.8946 35.0753 59.2839 34.304 55.7239 34.304H40.4159V52.104ZM58.3939 97.316C61.9539 97.316 64.5646 96.6633 66.2259 95.358C68.0059 93.934 68.8959 91.6793 68.8959 88.594C68.8959 82.542 65.3952 79.516 58.3939 79.516H40.4159V97.316H58.3939Z"/>
                <path d="M156.756 99.096H194.848V129H117.24V2.97597H156.756V99.096Z"/>
                <path d="M286.755 109.954H244.747L238.517 129H197.043L243.145 2.97597H288.713L334.637 129H292.985L286.755 109.954ZM277.143 80.228L265.751 45.162L254.359 80.228H277.143Z"/>
                <path d="M383.58 130.246C368.51 130.246 356.05 126.745 346.2 119.744C336.47 112.624 331.189 102.241 330.358 88.594H372.366C372.96 95.8326 376.164 99.452 381.978 99.452C384.114 99.452 385.894 98.9773 387.318 98.028C388.861 96.96 389.632 95.358 389.632 93.222C389.632 90.2553 388.03 87.882 384.826 86.102C381.622 84.2033 376.638 82.0673 369.874 79.694C361.805 76.846 355.1 74.0573 349.76 71.328C344.539 68.5986 340.03 64.6233 336.232 59.402C332.435 54.1806 330.596 47.476 330.714 39.288C330.714 31.1 332.791 24.158 336.944 18.462C341.216 12.6473 346.972 8.25663 354.21 5.28996C361.568 2.3233 369.815 0.839966 378.952 0.839966C394.379 0.839966 406.602 4.39997 415.62 11.52C424.758 18.64 429.564 28.6673 430.038 41.602H387.496C387.378 38.042 386.488 35.4906 384.826 33.948C383.165 32.4053 381.148 31.634 378.774 31.634C377.113 31.634 375.748 32.2273 374.68 33.414C373.612 34.482 373.078 36.0246 373.078 38.042C373.078 40.89 374.621 43.2633 377.706 45.162C380.91 46.942 385.954 49.1373 392.836 51.748C400.787 54.7146 407.314 57.5626 412.416 60.292C417.638 63.0213 422.147 66.8186 425.944 71.684C429.742 76.5493 431.64 82.6606 431.64 90.018C431.64 97.7313 429.742 104.673 425.944 110.844C422.147 116.896 416.629 121.643 409.39 125.084C402.152 128.525 393.548 130.246 383.58 130.246Z"/>
                <path d="M539.152 2.97597V34.304H505.688V129H466.172V34.304H433.064V2.97597H539.152Z"/>
                <path d="M607.898 129L584.224 83.788H584.046V129H544.53V2.97597H603.27C613.475 2.97597 622.197 4.8153 629.436 8.49396C636.675 12.054 642.074 16.9786 645.634 23.268C649.313 29.4386 651.152 36.44 651.152 44.272C651.152 52.6973 648.779 60.1733 644.032 66.7C639.404 73.2266 632.699 77.914 623.918 80.762L651.33 129H607.898ZM584.046 57.444H599.71C603.507 57.444 606.355 56.6133 608.254 54.952C610.153 53.172 611.102 50.4426 611.102 46.764C611.102 43.4413 610.093 40.8306 608.076 38.932C606.177 37.0333 603.389 36.084 599.71 36.084H584.046V57.444Z"/>
                <path d="M719.846 130.246C707.979 130.246 697.062 127.457 687.094 121.88C677.245 116.303 669.413 108.589 663.598 98.74C657.783 88.8906 654.876 77.7953 654.876 65.454C654.876 53.1126 657.783 42.0173 663.598 32.168C669.413 22.3186 677.245 14.6646 687.094 9.20596C697.062 3.62863 707.979 0.839966 719.846 0.839966C731.713 0.839966 742.571 3.62863 752.42 9.20596C762.269 14.6646 770.042 22.3186 775.738 32.168C781.553 42.0173 784.46 53.1126 784.46 65.454C784.46 77.7953 781.553 88.8906 775.738 98.74C770.042 108.589 762.21 116.303 752.242 121.88C742.393 127.457 731.594 130.246 719.846 130.246ZM719.846 93.4C727.678 93.4 733.73 90.908 738.002 85.924C742.274 80.8213 744.41 73.998 744.41 65.454C744.41 56.7913 742.274 49.968 738.002 44.984C733.73 39.8813 727.678 37.33 719.846 37.33C711.895 37.33 705.784 39.8813 701.512 44.984C697.24 49.968 695.104 56.7913 695.104 65.454C695.104 73.998 697.24 80.8213 701.512 85.924C705.784 90.908 711.895 93.4 719.846 93.4Z"/>
                <path d="M914.237 129H874.721L832.891 65.632V129H793.375V2.97597H832.891L874.721 67.412V2.97597H914.237V129Z"/>
                <path d="M1007.56 109.954H965.554L959.324 129H917.85L963.952 2.97597H1009.52L1055.44 129H1013.79L1007.56 109.954ZM997.95 80.228L986.558 45.162L975.166 80.228H997.95Z"/>
                <path d="M1087.71 2.97597V73.998C1087.71 79.8126 1088.95 84.4406 1091.45 87.882C1094.06 91.2046 1098.21 92.866 1103.91 92.866C1109.6 92.866 1113.81 91.2046 1116.54 87.882C1119.27 84.4406 1120.64 79.8126 1120.64 73.998V2.97597H1159.98V73.998C1159.98 85.9833 1157.48 96.248 1152.5 104.792C1147.52 113.217 1140.69 119.566 1132.03 123.838C1123.37 128.11 1113.7 130.246 1103.02 130.246C1092.34 130.246 1082.84 128.11 1074.54 123.838C1066.35 119.566 1059.94 113.217 1055.31 104.792C1050.68 96.3666 1048.37 86.102 1048.37 73.998V2.97597H1087.71Z"/>
                <path d="M1270.65 2.97597V34.304H1237.18V129H1197.67V34.304H1164.56V2.97597H1270.65Z"/>
                </svg>
            </div>
            </router-link>
        </div>
    </v-container>
</template>

<script>
export default {
  data: () => ({
    
  }),
};
</script>
<style scoped>
.header {
    /* padding: 0 14px; */
    /* margin: 48px auto; */
    /* padding-left: 22px; */
    margin: 66px auto;
    /* margin-bottom: 32px; */
}
.header.md {
    padding: 0 40px;
}
.header .logo {
    margin-top: 0;
    width: 32px;
    float: right;
    margin-right: 20px;
}
.header .logo.md {
    width: 40px;
    margin-right: 30px;
}

.header-title {
    letter-spacing: 0.18em;
    font-size: 26px;
    text-transform: uppercase;
    border: none;
    display: inline-block;
}
a {
    border: none;
}
.header-title.md {
    margin-top: -2px;
    font-size: 48px;
}
.logotype {
    font-size: 0;
}
.logotype>svg {
    width: 100%;
    fill: var(--text-color);
}

</style>